import React, { useEffect } from "react"
import { NumberTagFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"


export default function WeekSelector() {

	const {
		weekSelected,
		setWeekSelectedInfo,
		error
	} = useReportFormInfo(
		reportFormData.peek().weekSelected,
		"weekSelected",
		object({
			weekSelected: array()
				.required("Must provide a positive week number")
				.test("min", "Must provide a positive week number", () => !!weekSelected.length && weekSelected.every(e => +e >= 0))
		}))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setWeekSelectedInfo([], false)
		}
	}, [useCsv.value])

	return <NumberTagFieldSeeker
		value={weekSelected || []}
		onChange={e => setWeekSelectedInfo(e)}
		error={error}
		label="Week selected"
		placeholder="0 for actual week"
	/>
}